import { render, staticRenderFns } from "./ProductFieldOrder.vue?vue&type=template&id=8459de8a"
import script from "./ProductFieldOrder.vue?vue&type=script&lang=js"
export * from "./ProductFieldOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports